










import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  // variables que referencian a los stores
  private get version() {
    return process.env.VUE_APP_VERSION;
  }
}
